module.exports = __webpack_public_path__ + "static/media/stackoverflowIcon.a528466b.svg";